// app/components/approval/ApprovalBadge.tsx

import { NoOfApproverCell } from "@/app/components/common/table/KendoCustomCells";

interface ApprovalBadgeProps {
  numberOfApproved: number;
  numberOfLevels: number;
}

const ApprovalBadge = ({
  numberOfApproved,
  numberOfLevels,
}: ApprovalBadgeProps) => {
  const dataItem = { numberOfApproved, numberOfLevels };

  return (
    <span className="gx-approval-badge">
      <NoOfApproverCell dataItem={dataItem} />
    </span>
  );
};

export default ApprovalBadge;
